import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { StickerProvider, useSticker } from './context/StickerContext';
import { ToastProvider } from './components/ui/Toast';
import { StickersPage } from './pages/StickersPage';
import { ProofPage } from './pages/ProofPage';
import { EditorPage } from './pages/EditorPage';
import { Loader2 } from 'lucide-react';
function LoadingOverlay() {
  const {
    sessionLoading
  } = useSticker();
  return <AnimatePresence data-id="element-0">
      {sessionLoading && <motion.div initial={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed inset-0 z-[100] flex items-center justify-center bg-[#E1E1E1]/80 backdrop-blur-sm" data-id="element-1">
          <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.9
      }} transition={{
        duration: 0.2
      }} className="flex flex-col items-center gap-4 bg-white rounded-2xl shadow-xl px-10 py-8 border border-[#D9D9D9]" data-id="element-2">
            <Loader2 className="animate-spin text-[#008696]" size={36} data-id="element-3" />
            <p className="text-sm font-medium text-[#111111]" data-id="element-4">
              Loading your session…
            </p>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function App() {
  return <StickerProvider data-id="element-5">
      <ToastProvider data-id="element-6">
        <LoadingOverlay data-id="element-7" />
        <HashRouter data-id="element-8">
          <Routes data-id="element-9">
            <Route path="/" element={<Navigate to="/stickers" replace data-id="element-11" />} data-id="element-10" />
            <Route path="/stickers" element={<StickersPage data-id="element-13" />} data-id="element-12" />
            <Route path="/stickers/proof" element={<ProofPage data-id="element-15" />} data-id="element-14" />
            <Route path="/stickers/editor" element={<EditorPage data-id="element-17" />} data-id="element-16" />
          </Routes>
        </HashRouter>
      </ToastProvider>
    </StickerProvider>;
}